<template>

  <v-container>

    <div class="mt-10">
    <CRUDList class="mt-10"
    :canAdd="true" :canEdit="true" :canSave="true"
      :showSelect="true" :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
      :baseCrudKey="baseCrudKey"
      tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='200'
      dialogDynamicWidth='400'
      dialogHeaderName="Payment Under Protest"
      :defaultSortBy="defaultSortBy"
      :selectedItems="selectedItems"
      @emitSelectedItem="taxProtestSelectedItem"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      @loadCRUDList = "loadProtestsData"
      @upsertItem="upsrtTransaction"
       :footerTotalDisplayColumnWise="['Total',null,null, null, null,'','','','','','','','','','']"
      >
      <template v-slot:[`editedItem`]="{}">
          <ProtestTaxDialog :baseCrudKey="baseCrudKey" :showFund="true" />
        </template>
        <template
        v-if="isAdmin"
        v-slot:[`additionalActions`]="{}">
          <v-btn
            class="input-text-size"
            text
            color="error darken-1"
            :disabled="!editedItem._id"
            @click="deleteProtestTaxRecord"
          >
            Delete
          </v-btn>
        </template>
    </CRUDList>
    <template>
    </template>
    <CRUDDialog
        ref="crudDialog"
        :baseCrudKey='crudKeyForPayment'
        :canSave="false"
        :dialogHeaderName="dialogHeaderPayment"
         @crudDialogEnter="upsertPayments"
      ><template v-slot:[`editedItem`]="{}">
        <paymentDialog :baseCrudKey="crudKeyForPayment" />
        </template>
        <template v-slot:[`additionalActionsAfterSave`]="{}">
          <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || 'n/a'"
                :itemIsSaved="!isNewItem"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    :disabled="enableUploadFile"
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>
              <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(false)" :disabled="isSaveBlocked">Save</v-btn>
        <v-btn :class="`input-text-size`" text color="blue darken-1"
        @click="onUpsertCall(true)" :disabled="isSaveBlocked">Save & print</v-btn>

        </template>
      </CRUDDialog>
   <v-row class="mt-4 mb-2" align="center" justify="start">
      <v-checkbox class="input-text-size mr-4"
        :value="showFlaggedRecords"
        @change="toggleFlaggedRecords"
        :label="`Show flagged records only`"></v-checkbox>
      <v-checkbox class="input-text-size mr-4"
        :value="showResolved"
        @change="toggleShowResolved"
        :label="`Show resolved`"></v-checkbox>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="primary" small @click="handleProtestDiaog">
            Print Protest Tax List
          </v-btn>
        </template>
        <span> Print Protest Tax List</span>
      </v-tooltip>
    </v-row>

    <!-- Print Protest Tax Report Dialog -->
    <v-dialog v-model="printDialog" max-width="400">
      <v-card>
        <v-card-title class="">Print Protest Tax Report</v-card-title>
        <v-card-text>
          <v-checkbox v-model="printWithDetail" label="Print with detail" class="input-text-size" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="printDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="continuePrint">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>
<script>
import {
  mapActions, mapState, mapMutations, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { clients } from '../../../util/clients';
import { ProtestedTaxHeaders } from '../../shared/Utils/taxHeaders.utils';
import ProtestTaxDialog from './ProtestTaxDialog.vue';
import {
  amountFormat, amountToNumber, defaultGridLoading, isEmptyObject, manageGridLoading,
} from '../../../util/shared/vue-global';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import paymentDialog from '../payments/paymenteditDialog/paymentDialog.vue';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import '../../../assets/style.css';
import PaymentCommonFunc from '../common-utils/PaymentCommonFunc.mixin';
import UploadFile from '../../common/UploadFile.vue';
import { getWorkstationNumber } from '../../../util/workstation-util';

const { backendRest } = clients.direct;
export default {
  name: 'ProtestedTaxList',
  mixins: [PaymentCommonFunc],
  data() {
    return {
      baseCrudKey: 'protestedTax',
      headers: ProtestedTaxHeaders,
      gridLoading: defaultGridLoading(),
      crudKeyForPayment: 'paymentDialog',
      dialogHeaderPayment: 'Payment',
      activeTransItem: undefined,
      attachmentConstants: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileParams: {
        bucketName: 'taxPayment',
        program: 'taxPayment',
        parentObjectType: 'taxPayments',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      enableUploadFile: false,
      printDialog: false,
      printWithDetail: false,
      wkstNumber: getWorkstationNumber(),
      savedSelectedItemIds: [],
    };
  },
  components: {
    CRUDList,
    ProtestTaxDialog,
    paymentDialog,
    CRUDDialog,
    UploadFile,
  },
  mounted() {
    // Ensure clean state on initial mount - no selections unless explicitly saved
    if (this.savedSelectedItemIds.length === 0) {
      this.setShowFlaggedRecords(false);
      this.setShowResolved(false);
      this.selectedItems = [];
    }
    this.loadProtestsData();
  },

  computed: {
    ...mapGetters('auth/token', [
      'authUserRoles',
    ]),
    ...mapGetters('base/crud', ['item', 'items', 'criteria', 'isVisible', 'index']),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxProtests.selectedItems,
      showFlaggedRecords: (state) => state.tax.taxProtests.showFlaggedRecords,
      showResolved: (state) => state.tax.taxProtests.showResolved,
    }),

    defaultSortBy() {
      return [
      ];
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getActiveTransID() {
      return (this.activeTransItem || {})._id || 'n/a';
      // return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      // return !this.editedItem._id;
      return this.index(this.crudKeyForPayment) === -1;
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.crudKeyForPayment);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    isAdmin: {
      get() {
        return this.authUserRoles.includes('TmcSupport');
      },
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('tax/taxProtests', [
      'setSelectedItems',
      'setShowFlaggedRecords',
      'setShowResolved',
    ]),
    ...mapMutations('base/crud', [
      'setItem', 'setCriteria', 'setItems', 'setIsVisible', 'setIndex',

    ]),
    ...mapActions('tax/taxProtests', ['loadTaxProtests', 'upsertTaxProtest', 'upsertBulkTaxProtest', 'deleteTaxProtestById']),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPayment',
      'loadTaxPayments',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions(['flashSuccess', 'flashError', 'flashWarn']),
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        // Only clear selectedItems if we're not preserving selections
        // Never clear savedSelectedItemIds here - they should persist for restoration
        if (!this.showFlaggedRecords && this.savedSelectedItemIds.length === 0) {
          this.selectedItems = [];
        }
      });
    },
    restoreSelectedItems() {
      // Restore selections based on saved IDs after data load
      if (this.savedSelectedItemIds.length > 0) {
        const allItems = this.items(this.baseCrudKey) || [];
        // eslint-disable-next-line max-len
        const restoredSelections = allItems.filter((item) => this.savedSelectedItemIds.includes(item._id));
        this.$nextTick(() => {
          this.selectedItems = restoredSelections;
          // If showFlaggedRecords is enabled by user,
          // apply the filter to show only selected records
          if (this.showFlaggedRecords && restoredSelections.length > 0) {
            this.$nextTick(() => {
              this.searchByCriteria();
            });
          }
        });
      }
    },
    loadProtestsData() {
      manageGridLoading(this, true, 'Searching...');
      const { baseCrudKey } = this;
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
        // A closed-out protest has nothing left under protest, to refund or to release, so the
        // server leaves it out unless it is asked for. Records stay fully selectable when
        // shown, so interest can still be reviewed and printed.
        showResolved: this.showResolved,
      };
      this.loadTaxProtests({
        criteria,
        baseCrudKey,
        postProcessTrans: this.protestTaxPostProcessTrans,
      }).then(() => {
        this.setDefaultSelectedItems();
      }).finally(() => {
        this.allProtestTaxRecords = this.items(this.baseCrudKey) || [];
        // Restore selections if we have saved IDs
        this.restoreSelectedItems();
        manageGridLoading(this, false);
      });
    },
    taxProtestSelectedItem(id) {
      this.selectedItems = id;
      // Save the MongoDB IDs of selected items
      this.savedSelectedItemIds = (id || []).map((item) => item._id).filter(Boolean);
    },
    protestTaxPostProcessTrans(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.fundNo = (item.fund || {}).fund;

        // item.totalAmt = item.totalAmt
        // || amountToNumber((item.taxInquiryTransaction || {}).totalTax);
        // + amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // + amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // amountToNumber((item.taxInquiryTransaction || {}).totalTax);
        // eslint-disable-next-line max-len
        // item.totalPaid = item.totalPaid
        // || amountToNumber((item.taxInquiryTransaction || {}).totalTax)
        // - amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // item.amountStillDue = amountToNumber(amountToNumber(item.totalAmt)
        //  - amountToNumber(item.totalPaid));
        // these are not editable
        item.taxDue = amountToNumber((item.taxInquiryTransaction || {}).totalTax || 0);
        item.ownerName = item.taxInquiryTransaction ? `${(item.taxInquiryTransaction || '').name1
         || ''} ${(item.taxInquiryTransaction || '').name2 || ''}` : '';
        item.schoolDistrict = (item.taxInquiryTransaction || {}).schoolDistrict || '';
        item.totalPaid = amountToNumber((item.taxInquiryTransaction || {}).totalPaid || 0);
        // these can be editable
        // item.amountStillDue = amountToNumber(item.taxInquiryTransaction?.totalDue);
        // amountToNumber(amountToNumber(item.totalDue) - amountToNumber(item.totalPaid));
        // item.refundToTaxPayer = item.refundToTaxPayer
        // || amountToNumber(item.totalAmt) - amountToNumber(item.totalAmt);
        // item.releaseToApportion = item.releaseToApportion
        // || amountToNumber(item.amountPaidUnderProtest) - amountToNumber(item.refundToTaxPayer);

        // eslint-disable-next-line max-len
        item.totalRefund = amountToNumber(item.refundToTaxPayer) + (item.interestOfRefund);
        // eslint-disable-next-line max-len
        item.totalRelease = amountToNumber(item.releaseToApportion) + (item.interestOfRelease);
        updatedItems.push(item);
        // console.info('setadat', item.amountPaidNoProtest, item.totalPaid,
        // item.amountPaidUnderProtest, amountToNumber(amountToNumber(item.totalPaid) -
        // amountToNumber(item.amountPaidUnderProtest)));
      }
      return updatedItems;
    },

    async upsrtTransaction(item) {
      const updatedKeys = ['taxStillDue',
        'amountPaidUnderProtest', 'amountPaidNoProtest', 'totalDue', 'totalPaid', 'refundToTaxPayer', 'releaseToApportion', 'interestOfRelease', 'interestOfRefund'];

      const deletedKeys = ['taxrolladjustment', 'taxDue', 'taxInquiryTransaction', 'fundAmount', 'ownerName', 'sharedFund', 'totalTax', 'totalPaid', 'totalPayment', 'fundNo', 'totalAmt', 'taxDistrict', 'amountStillDue', 'name1', 'name2'];

      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      // Handle fund field properly - set to null if no valid fund is selected
      if (updatedItem.fund && updatedItem.fund._id) {
        updatedItem.fund = updatedItem.fund._id;
      }
      deletedKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(updatedItem, key)) {
          delete updatedItem[key];
        }
      });
      updatedKeys.forEach((key) => {
        if (updatedItem[key]) {
          updatedItem[key] = amountToNumber(updatedItem[key]);
        }
      });
      // Save current selections before upserting
      // eslint-disable-next-line max-len
      this.savedSelectedItemIds = (this.selectedItems || []).map((sel) => sel._id).filter(Boolean);

      await this.upsertTaxProtest({
        item: updatedItem,
        baseCrudKey,
        // postProcessTrans: this.protestTaxPostProcessTrans,
      }).then(() => {
        this.loadProtestsData();
      });
    },
    toggleShowResolved(newValue) {
      this.setShowResolved(!!newValue);
      // Round-trips: resolved records are filtered server side, not in the loaded page.
      this.loadProtestsData();
    },
    toggleFlaggedRecords(newValue) {
      // Update the store first
      this.setShowFlaggedRecords(newValue);
      // Then apply the filtering
      this.$nextTick(() => {
        this.searchByCriteria();
      });
    },
    async searchByCriteria() {
      if (this.showFlaggedRecords) {
        const itemData = this.selectedItems;
        this.setItems([this.baseCrudKey, itemData]);
        // Keep the saved IDs so selections persist
      } else {
        // Restore all loaded records from the store
        const allRecords = this.allProtestTaxRecords || [];
        this.setItems([this.baseCrudKey, allRecords]);
        // Re-apply the selection from the saved ids instead of clearing it, so the
        // same records stay selected across repeated check/uncheck toggles. Match
        // by _id (the CRUDList item-key) since the restored rows are new objects.
        await this.$nextTick();
        this.selectedItems = allRecords.filter(
          (record) => this.savedSelectedItemIds.includes(record._id),
        );
      }
    },
    deleteFieldsNotRequireToUpsert(item, isDeleteId = false) {
      const updatedItem = { ...item };
      if (isDeleteId) {
        delete updatedItem._id;
      }
      if (Array.isArray(updatedItem.taxDetails)) {
        updatedItem.taxDetails = updatedItem.taxDetails.map((taxDetail) => {
          const { Half, ...rest } = taxDetail;
          return rest;
        });
      }
      delete updatedItem.checkAmount;
      delete updatedItem.otherAmount;
      delete updatedItem.change;
      delete updatedItem.total;
      return updatedItem;
    },
    buildPaymentItem(element) {
      if (element.paymentType) {
        const amount = amountToNumber(element.amount);
        const updatedElement = {
          paymentType: element.paymentType,
          paidBy: element.paidBy,
          isReconcilled: element.isReconcilled,
          amount,
        };
        if (element.paymentType === 'CASH') {
          // updatedElement.cashReceived = amountToNumber(element.cashReceived);
          // updatedElement.cashChange = amountToNumber(element.cashChange);
        }
        if (element.paymentType === 'CREDIT') {
          updatedElement.creditType = element.creditType;
        }
        if (element.paymentType === 'CHECK') {
          updatedElement.checkNumber = element.checkNumber;
          // updatedElement.checkPaidBy = element.checkPaidBy;
        }
        if (element.paymentType === 'ECHECK') {
          updatedElement.checkNumber = element.checkNumber;
        }
        if (element.paymentType === 'EFT') {
          updatedElement.eftType = element.eftType;
        }
        return { ...updatedElement };
      }
      return { ...element };
    },
    async handlePayment(item) {
      const { baseCrudKey } = this;
      const updatedItem = this.deleteFieldsNotRequireToUpsert(item);
      if ((updatedItem.paymentDetails || []).length > 0) {
        updatedItem.paymentDetails = updatedItem.paymentDetails.map((element) => {
          const newUpdatedElement = this.buildPaymentItem(element);
          return {
            ...newUpdatedElement,
          };
        });
      }

      if ((updatedItem.taxDetails || []).length > 0) {
        updatedItem.taxDetails = updatedItem.taxDetails.map((element) => {
          const el = element;
          el.taxYear = parseInt(element.taxYear, 10);
          el.taxId = parseInt(element.taxId, 10);
          el.taxAmt = parseInt(el.taxAmt, 10);
          el.penaltyAmt = parseInt(el.penaltyAmt, 10);
          el.total = parseInt(el.total, 10);
          // if (el.reciept !== null) {
          //   el.reciept = el.reciept.toString();
          // }
          delete el.initialPenaltyAmt;
          delete el.initialTaxAmt;
          delete el.fee;
          const taxDetailItem = { ...el };
          return {
            ...taxDetailItem,
          };
        });
      }
      updatedItem.workstation = parseInt(updatedItem.workstation, 10);
      delete updatedItem.auditRecordsForVoid;
      const response = await this.upsertTaxPayment({
        item: updatedItem,
        baseCrudKey,
        postProcessTransaction: this.postProccessDataForPayment,
      });
      return response;
    },
    postProccessDataForPayment(items) {
      const updatedItems = [];

      // to get in crud-list
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        let checkAmount = 0;
        let cashAmount = 0;
        let otherAmount = 0;
        (item.paymentDetails || []).map((ft) => {
          if (ft.paymentType === 'CHECK') checkAmount += ft.amount;
          if (ft.paymentType === 'CASH') cashAmount += ft.amount;
          if (ft.paymentType === 'EFT') otherAmount += ft.amount;
          return [];
        });
        item.checkAmount = checkAmount;
        item.cashAmount = cashAmount;
        item.otherAmount = otherAmount;

        // to get cash-change
        if (item.paymentDetails && item.paymentDetails.length === 1 && item.paymentDetails[0].paymentType === 'CASH') {
          const total = item.taxDetails
            .reduce((acc, ft) => acc + amountToNumber(ft.total || 0), 0);
          const calcChange = item.paymentDetails[0].amount - total > 0
            ? item.paymentDetails[0].amount - total : 0;
          item.cashChange = amountFormat(calcChange);
        }

        if (item.taxDetails && item.taxDetails.length > 0) {
          let totalSum = 0;
          let voidValue;

          for (const taxDetail of item.taxDetails) {
            taxDetail.taxAmt = amountFormat(taxDetail.taxAmt);
            taxDetail.penaltyAmt = amountFormat(taxDetail.penaltyAmt);
            totalSum += taxDetail.total;
            voidValue = taxDetail.void;
          }

          item.total = totalSum;
          item.void = voidValue;
        } else {
          item.taxDetails = [];
        }

        updatedItems.push(item);
      }
      return updatedItems;
    },
    async upsertPayments(item) {
      // Enter-key save. Guarded like the buttons: pressing Enter while a save is already
      // running is a second submission and would create a second payment record.
      if (this.isDuplicateSaveClick()) return;
      try {
        await this.upsertTransaction(item, false, false);
        this.flashSuccess('Payment processed successfully');
      } catch (error) {
        console.error('Payment processing failed:', error);
        // Error handling is already done in the upsertTransaction method
      }
    },

    handleProtestDiaog() {
      const hasSelectedRecords = this.selectedItems && this.selectedItems.length > 0;
      if (hasSelectedRecords) {
        this.printDialog = true;
      } else {
        this.flashWarn('Must select at least one record');
      }
    },
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },

    async continuePrint() {
      // Close the dialog
      this.printDialog = false;
      // Get JWT token
      const { jwt } = await this.reAuth();

      // Check if records are selected
      const hasSelectedRecords = this.selectedItems && this.selectedItems.length > 0;

      // Build criteria for print
      const criteria = {
        printDetails: this.printWithDetail,
        token: jwt,
        allWkst: true,
        allTaxDistricts: true,
        allTaxTypes: true,
        allReasonCodes: true,
      };

      // If records are selected, pass their IDs; otherwise, show error
      if (hasSelectedRecords) {
        const selectedIds = this.selectedItems.map((item) => item._id).join(',');
        criteria.ids = selectedIds;
      } else {
        this.flashWarn('Must select at least one record');
        return;
      }

      // Build URL for print/export
      // Manually build query string to avoid encoding commas in taxYears and ids
      const params = [];
      Object.keys(criteria).forEach((key) => {
        if (key === 'taxYears' || key === 'ids') {
          params.push(`${key}=${criteria[key]}`); // do not encode commas
        } else {
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(criteria[key])}`);
        }
      });
      const toUrl = `${backendRest.defaults.baseURL}/taxInquiry/protest-tax?${params.join('&')}`;
      window.open(toUrl);
      // You can trigger the actual print/export logic here
      // e.g., this.exportProtestTaxReport(this.printWithDetail)
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
        // await this.upsrtTransaction(this.editedItem, false);
        await this.preUpsertTransaction(this.item(this.crudKeyForPayment), true, false, false);
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
        // this.setIsVisible([this.crudKeyForPayment, true]);
        await this.preUpsertTransaction(this.item(this.crudKeyForPayment), true, false, false);
        // this.setIsVisible([this.crudKeyForPayment, true]);
        rightClick();
      }
    },

    // activateTransaction(val) {
    //   this.activeTransItem = val;
    // },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: (this.activeTransItem || {})._id || 'n/a',
      });
    },
    settingFields(res) {
      this.activeTransItem = res;
      this.setItem([this.crudKeyForPayment, res]);
      this.setIndex([this.crudKeyForPayment, 0]);
    },
    updateActiveTransItem(res) {
      // Always update activeTransItem first
      this.settingFields(res);

      if (this.uploadFileClickParams.leftClickFlag) {
        this.$nextTick(() => {
          this.imagesLeftClick(this.uploadFileClickParams.leftClickDef);
          this.uploadFileClickParams.leftClickFlag = false;
          this.uploadFileClickParams.leftClickDef = undefined;
        });
      } else if (this.uploadFileClickParams.rightClickFlag) {
        this.$nextTick(() => {
          this.imagesRightClick(this.uploadFileClickParams.rightClickDef);
          this.uploadFileClickParams.rightClickFlag = false;
          this.uploadFileClickParams.rightClickDef = undefined;
        });
      }
      return false;
    },
    // Removed redundant upsrtTransaction method as it was causing issues
    // setDefaultSelectedItems() {
    //   this.$nextTick(() => {
    //     // this.selectedItems = [];
    //   });
    // },
    async preUpsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog) {
    // if (this.isValidFormProp(this.baseCrudKey).value) {
      this.enableUploadFile = true;
      // eslint-disable-next-line max-len
      const response = await this.upsertTransaction(item, avoidUpdatingCrudList, isItFromSaveNPrint, shouldCloseDialog);
      this.enableUploadFile = false;
      if (!isEmptyObject(response)) {
        this.updateActiveTransItem(response);
      }
    // this.setDefaultSelectedItems();
    // this.callTheBroadBand();
    // return response;
    // }
    // return [];
    },
    async deleteProtestTaxRecord() {
      const item = this.editedItem;
      if (window.confirm('Are you sure you want to delete this Tax Protest record?')) {
        const { baseCrudKey } = this;
        await this.deleteTaxProtestById({ item, baseCrudKey }).then(() => {
          this.setDefaultSelectedItems();
        });
      }
    },
    async onUpsertCall(isItFromSaveNPrint) {
      // Ignore a re-click / double-click while the first save is still running - see
      // isDuplicateSaveClick (two no-paymentNumber calls create two payment records).
      if (this.isDuplicateSaveClick()) return;
      const item = this.item(this.crudKeyForPayment);
      await this.upsertTransaction(item, false, isItFromSaveNPrint);

      // Close payment dialog first
      this.setIsVisible([this.crudKeyForPayment, false]);

      // Wait for parent component to handle upsert success
      this.$emit('upsertFuncCall');
    },

  },
  watch: {
    isVisibleProp(newVal) {
      // console.info('isVisibleProp changed to', newVal, this.activeTransItem);
      if (newVal) {
        this.$nextTick(() => { this.loadFiles(); });
      } else {
        this.activeTransItem = undefined;
      }
    },
  },

};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
